<script setup>
import { computed, ref, watch, nextTick } from "vue";

import Modal from "@/components/Modal";
import UserForm from "../users/UserForm";

const props = defineProps(["items", "category"]);

const modalOpen = ref(false);

function toggleModal() {
  modalOpen.value = !modalOpen.value;
}


</script>

<template>
  <div class="link-add" @click="modalOpen = true">Add User <span>+</span></div>
  <Modal :active="modalOpen" @toggle="toggleModal">
    <UserForm @newUser="toggleModal"></UserForm>
  </Modal>
</template>

<style scoped lang="scss">
.modal {
  input {
    position: sticky;
    top: 0;
  }
}
</style>
